export default "__VITE_ASSET__06493bca__"